import { Component } from '@angular/core';

@Component({
  selector: 'avs-reporting-overview',
  standalone: false,
  templateUrl: './reporting-overview.component.html',
  styleUrl: './reporting-overview.component.css'
})
export class ReportingOverviewComponent {

}
